import { render, staticRenderFns } from "./ShuttersDetails.vue?vue&type=template&id=2f31ec22"
import script from "./ShuttersDetails.vue?vue&type=script&lang=ts"
export * from "./ShuttersDetails.vue?vue&type=script&lang=ts"
import style0 from "./ShuttersDetails.vue?vue&type=style&index=0&id=2f31ec22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports